module.exports = __webpack_public_path__ + "img/usuarios_mask.edc3f0c1.svg";